export default __webpack_public_path__ + "static/media/Diverse.03ae2339.webp";